<template>
		<div @mouseleave="changeHeader" :class="states!='index'?'headerContainer':'headerContainer indexThe'">
			<img v-if="states!='index'" style="width: 229px;margin-left: 6.25rem;height: 65px;" :src="logoBannerData.logo" />
			<img v-else style="width: 229px;margin-left: 6.25rem;height: 70px;" :src="logoBannerData.logo2" />
			<div :class="states!='index'?'headerTitle':'headerTitle indexSo'">科研公共服务平台</div>
			<Menu ref="menu" style="flex: 1;"></Menu>
			<div :class="states!='index'?'bluesd':''" style="margin-right: 40px; color: white; width: 108px;height: 32px; display: flex;cursor: pointer;border: 1px solid #FFFFFF;align-items: center;justify-content: center;border-radius: 4px;" v-show="!token">
				<div class="HeaderLogin loginHover" @click="goTologin">登录</div>
				<div style="padding: 0 6px;">/</div>
				
				<div  @click="goToRegister" class="HeaderLogin loginHover">注册</div >
			</div>
			<div style="display: flex;margin-right: 3.125rem;cursor: pointer;align-items: center;" v-show="token">
				 <a-dropdown>
				<a-avatar @click="goToCore" style="margin-right: 0.825rem;" size="large" :src="user.hadepic"></a-avatar>
				  <a-menu slot="overlay">
				    <a-menu-item style="text-align: center;" >
				      <a  @click="goToCore" style="color: #1890FF;">个人中心</a>
				    </a-menu-item>
				   <a-menu-item style="text-align: center;" v-show="isUser==true">
				      <span @click="goToDevelop" style="color: #1890FF;">后台管理</span>
				    </a-menu-item>
				    <a-menu-item>
				  	<a-popconfirm style="text-align: center;" title="确认是否注销登录" ok-text="是" cancel-text="否" @confirm="logout">
				  		<a  href="javascript:;" style="color: #F64C4C">注销</a>
				  	</a-popconfirm>
				    </a-menu-item>
				  </a-menu>
				  </a-dropdown>
				  
				 <a-dropdown>
					  
				     <a style="color: black;" :class="states!='index'?'ant-dropdown-link':'ant-dropdown-link whites'" @click="e => e.preventDefault()">
				       {{user.realName}} <a-icon style="margin-left: 0.3125rem;" type="down" />
				     </a>
				     <a-menu slot="overlay">
				       <a-menu-item style="text-align: center;" >
				         <a  @click="goToCore" style="color: #1890FF;">个人中心</a>
				       </a-menu-item>
				      <a-menu-item style="text-align: center;" v-show="isUser">
				         <span @click="goToDevelop" style="color: #1890FF;">后台管理</span>
				       </a-menu-item>
				       <a-menu-item>
						    <a-popconfirm style="text-align: center;" title="确认是否注销登录" ok-text="是" cancel-text="否" @confirm="logout">
						        <a  href="javascript:;" style="color: #F64C4C">注销</a>
						     </a-popconfirm>
				       
				       </a-menu-item>
				     </a-menu>
				   </a-dropdown>
			</div>
			
		</div>
</template>

<script>
	import {logoBanner,SelPersonalData,Isadministrators} from '@/api/index.js'
	import Menu from '@/components/common/topMenu.vue'
	import { mapState } from 'vuex'
	export default{
		data(){
			return{
				states:'',
				logoBannerData:[],
				token: window.localStorage.getItem('Authorization')?window.localStorage.getItem('Authorization'):'',
				user: [],
				isUser:JSON.parse(window.localStorage.getItem('isUser'))?JSON.parse(window.localStorage.getItem('isUser')):false
			}
		},
		computed:{
			...mapState(['userMsg'])
		},
		components:{
			Menu
		},
		methods:{
			goTologin(){
				this.$router.push({path:'/login'})
			},
			changeHeader(){
				this.$refs.menu.navigateState = 0
			},
			reloadToken(){
				this.token=window.localStorage.getItem('Authorization')?window.localStorage.getItem('Authorization'):''
				this.user=this.userMsg
				this.isUser=JSON.parse(window.localStorage.getItem('isUser'))?JSON.parse(window.localStorage.getItem('isUser')):false
				console.log(this.token)
			},
			 logout(){
				 window.localStorage.removeItem('Authorization')
				  window.localStorage.removeItem('User')
				  window.localStorage.removeItem('UserMsg')
				 this.$store.commit("updateUserMsg",[])
				  window.localStorage.removeItem('UserId')
				   window.localStorage.removeItem('isUser')
				    window.sessionStorage.removeItem('newTabIndex')
					window.sessionStorage.removeItem('panes')
					window.sessionStorage.removeItem('fullPathList')
					window.sessionStorage.removeItem('cache')
				  this.reloadToken()
				  this.$parent.$children[1].changeAuthorization()
				
				  if(this.$route.path.split('/')[1]=="core"){
					  this.$router.push({path:'/'})
				  }
				 location.reload()
			 },
			 goToRegister(){
				 this.$router.push({path:'/register'})
			 },
			 goToCore(){
				
				  this.$router.push({path:'/core/workbench'})
				   this.$parent.$children[1].resetMenus()
			 },
			 goToDevelop(){
			 	console.log("ddd")
				if(process.env.NODE_ENV=='development'){
					window.open('http://192.168.2.5:5015/client/SinglesignonApi?token='+'Bearer '+window.localStorage.getItem('Authorization')+'&userid='+window.localStorage.getItem('UserId'),'_blank')
				}else{
					window.open('http://wdrm-admin.zkshare.com/client/SinglesignonApi?token='+'Bearer '+window.localStorage.getItem('Authorization')+'&userid='+window.localStorage.getItem('UserId'),'_blank') 
				}
			 	
			 },
			 async getLogoBanner(){
			 	const res = await logoBanner()
			 		this.logoBannerData=res.data.data
			 }
		},
		watch: {//动态监听路由变化 -以便动态更改导航背景色事件效果等
		            '$route' (to, from) {
		              // 对路由变化作出响应...
		            console.log("执行")
		            let current1 = this.$route.path
		            console.log(current1)
		            if(current1=='/'){
						this.states = 'index'
					}
					else{
						this.states = ''
					}
					
		  }
		},
		created(){
			
			this.getLogoBanner()
			let ifLogin = window.localStorage.getItem('Authorization')
			if(ifLogin){
				Isadministrators().then((res)=>{
					window.localStorage.setItem('isUser',res.data.state)
					this.isUser = res.data.state
				})
				SelPersonalData().then((res)=>{
					this.$store.commit("updateUserMsg",res.data.data)
					this.user = res.data.data
					
			})
				}
		},
	}
</script>

<style  scoped>
	.headerContainer{
		width: 100%;
		min-width: 1376px;
		height: 100px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		
	}
	.headerTitle{
		font-family: Microsoft YaHei;
		font-style: normal;
	/* 	font-weight: 600; */
		font-size: 24px;
		/* letter-spacing: 5.5px; */
		color: #004E97;
		/* flex: 1; */
		margin-left: 20px;
	
	}
	.HeaderLogin{
		/* 常规内容 */
		
		font-family: Microsoft YaHei;
		font-style: normal;
		font-weight: normal;
		font-size: 14px;
		/* color: rgba(0, 0, 0, 0.85); */
	}
	.loginHover:hover{
		/* color: rgba(0, 78, 151,0.5) !important; */
		opacity: 0.7;
	}
	.indexThe{
		background: rgba(5, 25, 47, 0.5) !important;
		position: fixed;
		top: 0 !important;
		z-index: 899;
	}
	.indexSo{
		color: white !important;
	}
	.whites{
		color: white !important;
		background-color: transparent !important;
	}
	.bluesd{
		color: #165FDC !important;
		border-color: #165FDC !important;
	}
</style>
